import { useEffect, useState } from 'react';
import { AdminSidebar, Icon, formatBRL } from '../../components/shared';
import api from '../../services/api';

export default function MasterDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/dashboard/master').then(r => setData(r.data)).catch(console.error).finally(() => setLoading(false));
  }, []);

  const totalEmpresas  = data?.empresas_status?.reduce((a, e) => a + parseInt(e.count), 0) || 0;
  const ativas         = data?.empresas_status?.find(e => e.status === 'ativa')?.count || 0;

  return (
    <div className="admin-layout">
      <AdminSidebar perfil="master" />
      <div className="main-content">
        <div className="topbar">
          <h1>Dashboard Master</h1>
          <span style={{ fontSize: '.8rem', color: 'var(--text-muted)' }}>
            {new Date().toLocaleDateString('pt-BR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
          </span>
        </div>
        <div className="page-content">
          {loading ? <div className="loading-center"><div className="spinner" /></div> : (
            <>
              <div className="stats-grid">
                <div className="stat-card orange">
                  <div className="icon"><Icon name="building" size={20} /></div>
                  <div className="label">Total de Empresas</div>
                  <div className="value">{totalEmpresas}</div>
                </div>
                <div className="stat-card green">
                  <div className="icon"><Icon name="check" size={20} /></div>
                  <div className="label">Empresas Ativas</div>
                  <div className="value">{ativas}</div>
                </div>
                <div className="stat-card blue">
                  <div className="icon"><Icon name="orders" size={20} /></div>
                  <div className="label">Total de Pedidos</div>
                  <div className="value">
                    {data?.top_empresas?.reduce((a, e) => a + parseInt(e.pedidos), 0) || 0}
                  </div>
                </div>
                <div className="stat-card yellow">
                  <div className="icon"><Icon name="chart" size={20} /></div>
                  <div className="label">Faturamento Global</div>
                  <div className="value" style={{ fontSize: '1.3rem' }}>{formatBRL(data?.faturamento_global)}</div>
                </div>
              </div>

              <div className="table-card">
                <div className="table-header">
                  <h3>Top Empresas por Faturamento</h3>
                </div>
                <div className="table-wrapper">
                  <table>
                    <thead>
                      <tr><th>Empresa</th><th>Pedidos</th><th>Faturamento</th></tr>
                    </thead>
                    <tbody>
                      {data?.top_empresas?.map((e, i) => (
                        <tr key={i}>
                          <td><strong>{e.nome_fantasia}</strong></td>
                          <td>{e.pedidos}</td>
                          <td style={{ color: 'var(--primary)', fontWeight: 700 }}>{formatBRL(e.faturamento)}</td>
                        </tr>
                      ))}
                      {!data?.top_empresas?.length && (
                        <tr><td colSpan={3} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>Nenhum dado disponível</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div style={{ marginTop: '20px' }}>
                <h3 style={{ marginBottom: '12px' }}>Status das Empresas</h3>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  {data?.empresas_status?.map(e => (
                    <div key={e.status} style={{
                      background: 'var(--bg-card)', border: '1px solid var(--border)',
                      borderRadius: 'var(--radius)', padding: '14px 20px', minWidth: '120px',
                    }}>
                      <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{e.count}</div>
                      <div style={{ fontSize: '.8rem', color: 'var(--text-muted)', textTransform: 'capitalize' }}>{e.status}</div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
